import Dexie from 'dexie';

class MyDatabase extends Dexie {
  constructor() {
    super('contentRecommendationListDatabase');

    // Initialize with the first version, assuming no stores
    this.version(1).stores({});
  }

  async createCustomerStore(customerId) {
    const customerStore = `${customerId?.replace('_', '')}_store`;
    const tableExists = this.tables.some((table) => table.name === customerStore);
    if (!tableExists) {
      const currentVersion = this.verno;
      const newVersion = currentVersion + 1;
      const newSchema = {};
      this.tables.forEach((table) => {
        newSchema[table.name] = table.schema.primKey.keyPath;
      });
      newSchema[customerStore] =
        '++id, content_recommendations.cr_list_id, content_recommendations.uuid, content_recommendations.rank, content_recommendations.insight, content_recommendations.insight_details, content_recommendations.monthly_clicks, content_recommendations.monthly_impressions, content_recommendations.paid_monthly_clicks, content_recommendations.paid_monthly_impressions, content_recommendations.data_source, content_recommendations.monthly_conversions, content_recommendations.cat_subcat, content_recommendations.urls_impacted, content_recommendations.finalurl, content_recommendations.site, content_recommendations.suggested_implementation, content_recommendations.created_date, content_recommendations.updated_date, content_recommendations.recommendations_type, content_recommendations.resolution, content_recommendations.keyword_alignment_score, content_recommendations.projected_keyword_alignment_score, content_recommendations.row_id, content_recommendations.branded_keyword_alignment_score, content_recommendations.non_branded_keyword_alignment_score, content_recommendations.content_quality_score, content_recommendations.organic_rank, content_recommendations.paid_rank, content_recommendations.additional_metrics, content_recommendations.is_cnp, content_recommendations.dfs_search_volume, content_recommendations.country, content_recommendations.language, content_recommendations.is_sandbox_data, entity_type, entity_id, annotation_desc, date, annotation_type, annotation_subtype, annotation_details, created_by, updated_by, updated_on, isResolved, projectedContentQualityScore, content_recommendations.projected_branded_alignment_score, content_recommendations.projected_non_branded_alignment_score';
      this.version(newVersion).stores(newSchema);
      await this.open();
    }

    return this.table(customerStore);
  }
}

const db = new MyDatabase();
export default db;
